// extracted by mini-css-extract-plugin
module.exports = {"notificationMeta":"index_notificationMeta__1IakH"};